<!-- eslint-disable -->
<template lang="pug">
    .row.school-preview
        .col-xs-10.school-preview__column.school-preview__column_hide-name
            .school-preview__item
                .school-preview__avatar
                    svg-icon.school-preview__icon(name="university", size="x-large")
                router-link.preview__text.preview__text_large.school-preview__link.school-preview__link_large(:to="{name: 'school:profile', params: {id: profile.id}}")
                    | {{ profile.name }}
        .col-xs-2.col-sm-1.last-sm.end-xs.school-preview__column
            dropdown(v-if="!type" :icon="false" :is-last="isLast" without-move)
                template(slot="link")
                    svg-icon.school-preview__icon.school-preview__icon_blue(name="select", :size="selectorSize")
                ul.dropdown__links
                    li.dropdown__link
                        router-link.school-preview__link(:to="{name: 'school:profile', params: {id: profile.id}}")
                            | {{ $i18n.t('list.list_common_actionsOpen') }}
                    li.dropdown__link(v-if="isEditable")
                        router-link.school-preview__link(:to="{name: 'school:edit', params: {id: profile.id}}")
                            | {{ $i18n.t('list.list_common_actionsEdit') }}
                    li.dropdown__link(v-if="isShowLink")
                        a(
                            href="javascript://"
                            @click="changeStatus"
                            v-if="profile.status === 'active'"
                        )
                            | {{ $i18n.t('list.list_common_actionsArchive') }}
                        a(
                            href="javascript://"
                            @click="changeStatus"
                            v-else
                        )
                            | {{ $i18n.t('list.list_common_actionsRestore') }}
                    li.dropdown__link(v-if="isShowLink")
                        a(
                            href="javascript://"
                            @click="displayConfirmDeleteModal = true"
                        )
                            | {{ $i18n.t('list.list_common_actionsDelete') }}
            div(v-else-if="user && user.isSuperadmin")
                router-link.school-preview__link(
                    :to="{name: 'billing:edit', params: {id: profile.id}}"
                )
                    | {{ $i18n.t('list.list_common_settings') }}
        .col-xs-12.col-sm-11.school-preview__column
            .school-preview__name.hidden-xs
                router-link.school-preview__link.school-preview__link_large(
                    :to="{name: 'school:profile', params: {id: profile.id}}"
                )
                    .school-preview__avatar
                        svg-icon.school-preview__icon(name="university", size="x-large")
                    .preview__text.preview__text_large
                        | {{ profile.name }}
            .row.school-preview__info
                .col-md-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item
                            template(v-if="profile.status === 'active'")
                                svg-icon.school-preview__icon(name="check")
                                .preview__text {{ $i18n.t('common.common_status_active') }}
                            template(v-else)
                                svg-icon.school-preview__icon(name="cancel")
                                .preview__text {{ $i18n.t('common.common_status_archived') }}
                        .school-preview__item
                            a.school-preview__link(v-if="profile.phone" :href="'tel:' + profile.phone")
                                svg-icon.school-preview__icon(name="phone", size="base")
                                .preview__text
                                    | {{ profile.phone }}
                            template(v-else="")
                                svg-icon.school-preview__icon(name="phone", size="base")
                                .preview__text
                                    | {{ $i18n.t('list.list_user_noPhone') }}
                .col-md-6.info__column
                    .school-preview__items.school-preview__items_columned
                        .school-preview__item(v-if="profile.mainContact")
                            small-user-preview(
                                :profile-type="$i18n.t('list.list_schoolPreview_mainContact')"
                                :displayed-user="profile.mainContact"
                            )
                        .school-preview__item(v-else)
                            | {{ $i18n.t('list.list_schoolPreview_noMainContact') }}
        confirm-delete-modal(
            v-if="displayConfirmDeleteModal"
            @close="displayConfirmDeleteModal = false"
            @delete="$emit('delete', profile.id)"
        )
            | {{ " " + $i18n.t('list.list_schoolPreview_thisSchool') }}
</template>

<script>
    /*eslint-disable*/
    import Dropdown from '../../../elements/Dropdown.vue';
    import SchoolApi from '../../../api/school';
    import {mapState} from 'vuex';
    const ConfirmDeleteModal = () => import('../../../modals/ConfirmDeleteModal.vue');
    import usersListMixin from "../../../utils/user/usersListMixin"
    import SmallUserPreview from '../../profiles/default-elements/SmallUserPreview.vue'

    export default {
        mixins: [usersListMixin],
        props: {
            profile: Object,
            isLast: Boolean
        },
        mounted () {
            if (this.$route.name.includes('billing')) {
                this.type = 'billing';
            }
        },
        data() {
            return {
                displayConfirmDeleteModal: false,
                type: '',
            }
        },
        components: {
            SmallUserPreview,
            Dropdown,
            ConfirmDeleteModal
        },
        computed:  {
            ...mapState({
                user: state => state.auth.user,
            }),
            isEditable () {
                return this.profile.status === 'active' &&
                    (this.user.isSuperadmin || this.user.isManagerOrSupport) || (this.user.type === 'admin' && this.user.schoolsIds.includes(this.profile.id))
            },
            balanceString () {
                if (this.type && this.profile.isBillingActive ? this.profile.account : false) {
                    return this.profile.account.balance + " " + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', this.profile.account.balance);
                }
                return "";
            },
            selectorSize () {
                const windowWidth = window.innerWidth;
                return windowWidth >= 1200 ? 'xx-large' : 'x-large';
            },
            isShowLink () {
                return this.user.isSuperadmin || this.user.isManagerOrSupport;
            },
        },
        methods: {
            changeStatus() {
                let coursesIds = this.profile.courses.map(course => course.id);
                if (this.profile.status === 'archived') {
                    this.profile.status = 'active';
                } else {
                    this.profile.status = 'archived';
                }
                SchoolApi.update(this.profile.id, {status: this.profile.status, mainContact: this.profile.mainContact, coursesIds})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .school-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .school-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 8px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .school-preview__column:last-child {
        margin-bottom: 0;
    }

    .school-preview__column:first-child {
        margin-bottom: 16px;
    }

    .school-preview__column_hide-name {
        @include media($sm) {
            display: none;
        }
    }

    .school-preview__name {
        margin-bottom: 16px;
        display: flex;
        align-items: center;
    }

    .school-preview__avatar {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $border-radius-circle;
        background-color: #F3F8EF;
    }

    .school-preview__icon {
        color: $hsl-color-green-58;
    }

    .school-preview__icon_blue {
        color: $hsl-color-blue-56;
    }

    .school-preview__items {
        display: flex;
        margin: -4px 0;
    }

    .school-preview__items_columned {
        flex-direction: column;
    }

    .school-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;

        padding: 4px;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .school-preview__link {
        display: flex;
        align-items: center;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school-preview__item:not(:last-child) {
        margin-bottom: 8px;
    }

    .school-preview__info {
        margin: -8px 0;
    }

    .info__column {
        padding: 8px 0;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__text_large {
        margin-left: 16px;
    }

    .school-preview__link {
        display: flex;
        color: $hsl-color-blue-56;
        text-decoration: none;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .school-preview__link_large {
        font-size: 16px;
        line-height: 20px;
        @include media($lg) {
            font-size: 18px;
        }
    }

    .custom-dropdown {
        top: 0;
        left: 0;
    }

    .dropdown__links {
        padding: 7px 14px;
        text-align: left;
        font-size: 16px;
        line-height: 26px;
    }

    .dropdown__link {
        padding-bottom: 7px;
        a {
            color: $hsl-color-blue-56;
            text-decoration: underline;
            &:hover {
                color: $hsl-color-blue-56;
                text-decoration: none;
            }
        }
    }
</style>

